export const PRE_ACCESS_PAGE_SIZE = 1000;

export const PRE_ACCESS_DEFAULT_CARBON_SORT_COLUMN = "results.vintageStartDate";
export const PRE_ACCESS_DEFAULT_BIODIVERSITY_SORT_COLUMN = "results.issuanceDate";

export const PRE_ACCESS_TOTAL_COLUMN_NAMES = ["unitQuantityTotal", "unitQuantityAvailable"];

export const PRE_ACCESS_VERIFIED_STATUS = "Verified";
export const PRE_ACCESS_VERIFIED_QUANTITY_TYPES = ["WCU", "PCU", "WCC"];
